// extracted by mini-css-extract-plugin
export default {"addMoreKeys":"KeyInformation_addMoreKeys__XYXhV","hidden":"KeyInformation_hidden__C77Lz","header":"KeyInformation_header__r5j-Y","text":"KeyInformation_text__0uZOe"};